// Chrome ignores `autocomplete="off"` for recognized fields (name, email, phone, address), so
// `"new-password"` is the reliable value for suppressing browser autofill/suggestions on form inputs.
export const DISABLE_BROWSER_AUTOFILL = 'new-password';

export const TEXT_AREA_MAX_LENGTH = 800;
